//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiClose, mdiLinkVariant } from '@mdi/js'

export default {
  setup() {
    const connectedAccounts = [
      {
        img: 'google.png',
        title: 'Google',
        text: 'Calendar and contacts',
        connected: true,
      },
      {
        img: 'slack.png',
        title: 'Slack',
        text: 'Communication',
        connected: false,
      },
      {
        img: 'github.png',
        title: 'Github',
        text: 'Manage your Git repositories',
        connected: true,
      },
      {
        img: 'mail-chimp.png',
        title: 'Mailchimp',
        text: 'Email marketing service',
        connected: false,
      },
      {
        img: 'asana.png',
        title: 'Asana',
        text: 'Communication',
        connected: false,
      },
    ]

    const socialAccounts = [
      {
        img: 'facebook.png',
        title: 'Facebook',
        connected: false,
      },
      {
        img: 'twitter.png',
        title: 'Twitter',
        link: 'https://twitter.com/theme_selection',
        username: '@Theme_Selection',
        connected: true,
      },
      {
        img: 'linkedin.png',
        title: 'Linkedin',
        link: 'https://www.linkedin.com/company/themeselection',
        username: '@ThemeSelection',
        connected: true,
      },
      {
        img: 'dribbble.png',
        title: 'Dribbble',
        connected: false,
      },
      {
        img: 'behance.png',
        title: 'Behance',
        connected: false,
      },
    ]

    return {
      connectedAccounts,
      socialAccounts,
      icons: {
        mdiClose,
        mdiLinkVariant,
      },
    }
  },
}
